import { render, staticRenderFns } from "./AIChatBoxForAccidentIncident.vue?vue&type=template&id=bb241018&scoped=true&"
import script from "./AIChatBoxForAccidentIncident.vue?vue&type=script&lang=js&"
export * from "./AIChatBoxForAccidentIncident.vue?vue&type=script&lang=js&"
import style0 from "./AIChatBoxForAccidentIncident.vue?vue&type=style&index=0&id=bb241018&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb241018",
  null
  
)

export default component.exports